import prepareOptions from '../../prepareOptions';

import {
  VALUE_5000,
  VALUE_10000,
  VALUE_20000,
  VALUE_30000,
  VALUE_40000,
  VALUE_50000,
  VALUE_60000,
  VALUE_70000,
  VALUE_80000,
  VALUE_90000,
  VALUE_100000,
  VALUE_125000,
  VALUE_150000,
  VALUE_175000,
  VALUE_200000,
  VALUE_225000,
  VALUE_250000,
  VALUE_275000,
  VALUE_300000,
} from './values';

export default prepareOptions([
  VALUE_5000,
  VALUE_10000,
  VALUE_20000,
  VALUE_30000,
  VALUE_40000,
  VALUE_50000,
  VALUE_60000,
  VALUE_70000,
  VALUE_80000,
  VALUE_90000,
  VALUE_100000,
  VALUE_125000,
  VALUE_150000,
  VALUE_175000,
  VALUE_200000,
  VALUE_225000,
  VALUE_250000,
  VALUE_275000,
  VALUE_300000,
]);
